export default {
    logoAlt: 'VR Lab emblem',
    brand: {
      title: 'VR Lab',
      tagline: 'Jinan University',
    },
    nav: [
      { to: '/', label: 'Home' },
      { to: '/members', label: 'Members' },
      { to: '/publications', label: 'Publications' },
      { to: '/teaching', label: 'Teaching' },
      { to: '/opening', label: 'Opening' },
    ],
    language: {
      label: 'Language',
      trigger: 'English',
      options: {
        en: 'English',
        zh: '中文',
      },
    },
    mobileMenu: {
      open: 'Open navigation menu',
      close: 'Close navigation menu',
      label: 'Primary navigation',
    },
    footer: 'Copyright © {year} VR Lab · Jinan University',
  };
